export function dadosPagamentoFactory(dados) {
  if (!dados) {
    return {
      idProcesso: 0,
      valores: {
        valorSaldoPrincipal: 0,
        valorMulta: 0,
        valorProtesto: 0,
        valorJurosCliente: 0,
        valorComissaoPagaCliente: 0,
        valorJurosABE: 0,
        valorHonorarios: 0,
        valorComercial: 0,
        valorNegociador: 0,
        valorAdvogado: 0,
        valorDSR: 0,
        valorPago: 0,
      },
    };
  }

  return {
    idProcesso: dados?.idProcesso ?? 0,
    valores: {
      valorSaldoPrincipal: Number(dados?.valorSaldoPrincipal) || 0,
      valorMulta: Number(dados?.valorMulta) || 0,
      valorProtesto: Number(dados?.valorProtesto) || 0,
      valorJurosCliente: Number(dados?.valorJurosCliente) || 0,
      valorComissaoPagaCliente: Number(dados?.valorComissaoPagaCliente) || 0,
      valorJurosABE: Number(dados?.valorJurosABE) || 0,
      valorHonorarios: Number(dados?.valorHonorarios) || 0,
      valorComercial: Number(dados?.valorComercial) || 0,
      valorAdvogado: Number(dados?.valorAdvogado) || 0,
      valorNegociador: Number(dados?.valorNegociador) || 0,
      valorDSR: Number(dados?.valorDSR) || 0,
      valorPago: Number(dados?.valorPago) || 0,
    },
  };
}
